import { ReactRenderer } from '@tiptap/react';
import tippy from 'tippy.js';
import MentionList from './components/MentionList';
import type { SuggestionOptions } from './suggestionProsePlugin';
import { PluginKey } from '@tiptap/pm/state';
import { EXTENSION_TYPE_NAME } from './constants';

export const MentionPluginKey = new PluginKey(EXTENSION_TYPE_NAME);

export const suggestionExtensionConfig: Omit<SuggestionOptions, 'editor'> = {
  char: '@',
  pluginKey: MentionPluginKey,

  command: ({ editor, range, props }) => {
    // increase range.to by one when the next node is of type "text"
    // and starts with a space character
    const nodeAfter = editor.view.state.selection.$to.nodeAfter;
    const overrideSpace = nodeAfter?.text?.startsWith(' ');

    if (overrideSpace) {
      range.to += 1;
    }

    editor
      .chain()
      .focus()
      .insertContentAt(range, [
        {
          type: EXTENSION_TYPE_NAME,
          attrs: props,
        },
        {
          type: 'text',
          text: ' ',
        },
      ])
      .run();

    window.getSelection()?.collapseToEnd();
  },

  allow: ({ state, range }) => {
    const $from = state.doc.resolve(range.from);
    const type = state.schema.nodes[EXTENSION_TYPE_NAME];
    return !!$from.parent.type.contentMatch.matchType(type);
  },

  render: () => {
    let component;
    let popup;

    return {
      onStart: props => {
        component = new ReactRenderer(MentionList, {
          props,
          editor: props.editor,
        });

        if (!props.clientRect) {
          return;
        }

        popup = tippy('body', {
          getReferenceClientRect: props.clientRect,
          appendTo: () => document.body,
          content: component.element,
          showOnCreate: true,
          interactive: true,
          trigger: 'manual',
          placement: 'bottom-start',
          // TODO: Figure out the type issue here
        } as any);
      },

      onUpdate(props) {
        component.updateProps(props);

        if (!props.clientRect) {
          return;
        }

        if (popup[0].state.isDestroyed) {
          return;
        }

        popup[0].setProps({
          getReferenceClientRect: props.clientRect,
        });
      },

      onKeyDown(props) {
        if (props.event.key === 'Escape') {
          popup[0].hide();

          return true;
        }

        if (props.event.key === ' ') {
          props.editorCommands.daMentionTryMention(props.query, props.range);
        }

        return component.ref?.onKeyDown(props);
      },

      onExit() {
        if (!popup[0].state.isDestroyed) {
          popup[0].destroy();
        }
        component.destroy();
      },
    };
  },
};
